import { Env } from "@stencil/core";

export const rootElementMetadata = {
  "data-build-date": Env.buildDate,
  "data-commit-sha": Env.commitSHA,
  "data-pipeline-id": Env.pipelineID,
} as const;
